import React from 'react';
import { styled } from '@compiled/react';

import { LoadableAfterPaint } from '@confluence/loadable';

import type {
	TemplateBreadcrumbsWithActionProps,
	TemplateBreadcrumbsProps,
} from './templateBreadcrumbsTypes';

export type { UpdateTemplateContentAppearanceRequest } from './templateBreadcrumbsTypes';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyArea = styled.div({
	width: '100%',
	height: '32px',
});

export const TemplateBreadcrumbs = LoadableAfterPaint<TemplateBreadcrumbsWithActionProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TemplateBreadcrumbsWithActions" */ './TemplateBreadcrumbsWithActions'
			)
		).TemplateBreadcrumbsWithActions,
	loading: () => <EmptyArea />,
});

export const TemplateBreadcrumbsComponent = LoadableAfterPaint<TemplateBreadcrumbsProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateBreadcrumbs" */ './TemplateBreadcrumbs'))
			.TemplateBreadcrumbs,
});
